import GameObject from '../../../GameObject/GameObject';
import AnimationClip, { AnimationClipEvent } from '../AnimationClip';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import TransformComponent from '../../../Component/Transform';
import { StartAnimation } from '../AnimationHelper';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';
import { CARD_STACK_OFFSET } from '../../../Constants/InGame';
import CardSystem from '../../Card/CardSystem';
import CardComponent from '../../../Component/Level/Card';

interface ICardPlusFiveMeta {
    system: CardSystem;
    targetCards: BaseCard[];
    stackContainer: GameObject;
}

export class CardPlusFive extends AnimationClip {
    public *execute(
        animator: GameObject,
        meta: ICardPlusFiveMeta
    ): IterableIterator<number> {
        // Set position of all cards first to fix stack counter.
        for (let card of meta.targetCards) {
            meta.stackContainer.addChild(card);
            const transform = card.getComponent(TransformComponent);
            transform.position.set(-200, 200);
        }

        for (let i = 0; i < meta.targetCards.length; i++) {
            const card = meta.targetCards[i];
            const transform = card.getComponent(TransformComponent);
            card.getComponent(Renderable).visible = true;
            card.getComponent(CardComponent).skipStackAlign = true;
            StartAnimation(card, 'CardSlide', {
                x: CARD_STACK_OFFSET,
                y: 0,
            }).on(AnimationClipEvent.COMPLETE, () => {
                transform.rotation = 0;
                card.getComponent(CardComponent).skipStackAlign = false;
                meta.system.cardStack.align();
            });

            // Delay between each card sliding in.
            yield* delay(100);
        }

        yield* delay(200);
    }
}
